/* 
    This is the assign devices popup in the code editor, with checkboxes and no input field.
*/


let assign_devices_template = `<div id="dialog-assign-devices" class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      Assign Devices
      <button class="btn-close" data-dismiss="modal"><span class="fa fa-times"></span></button>
      <div class="modal-alert-container">
        <div class="alert"></div>
      </div>
    </div>
    <form class="table-container">
      <div class="modal-body pagination">{{! pagination controls }}</div>
      <div class="modal-body devices-table table-container-lg">
        {{! devices table region }}
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" data-dismiss="modal">Cancel</button>
        <button type="submit" class="btn btn-primary" disabled>Assign</button>
      </div>
    </form>
    <div class="response-container">
      <div class="modal-body response">{{! response region }}</div>
      <div class="modal-footer">
        <button class="btn btn-link" data-dismiss="modal">Cancel</button>
        <button class="btn btn-primary try-again">Try Again</button>
      </div>
    </div>
  </div>
</div>`;

let assign_devices_device_template = `
<td><input type="checkbox" value="{{id}}" name="selected-device"></td>
<td class="item-id">{{id}}{{#if name}}<div class='device-list-name'>{{name}}</div>{{/if}}</td>
{{#if show.type}}<td class="type">{{device_type}}</td>{{/if}}
<td class="status {{status}}">{{status}}</td>
{{#if show.rel_owner}}
<td class="owner"><span class="weak-text">Unassigned</span></td>
{{/if}}
{{#if show.rel_account}}
<td class="account"><span class="weak-text">Unassigned</span></td>
{{/if}}
{{#if show.rel_product}}
<td class="product"><span class="weak-text">Unassigned</span></td>
{{/if}}
{{#if show.rel_devicegroup}}
<td class="group"><span class="weak-text">Unassigned</span></td>
{{/if}}
{{#if show.last_enrolled}}
<td class="enrolled">
  {{#if last_enrolled_at}}
    {{#date_UTC}}{{last_enrolled_at}}{{/date_UTC}}
  {{else}}
   <span class="weak-text">Unenrolled</span>
  {{/if}}
</td>
{{/if}}`;

import _ from 'underscore';
import Handlebars from 'handlebars';
import Marionette from 'backbone.marionette';
import DialogInterface from '@/interfaces/dialog';
import CollectionTableView from '@/views/collection_table';
import DeviceView from '@/views/device';
import ResponseResultsView from '@/views/response_results_view';

var AssignDevicesDeviceView = DeviceView.extend({
    template: Handlebars.compile(assign_devices_device_template),
    events : {
        'click' : 'check',
        'click @ui.checkbox' : 'check'
    },
    check: function(){
        var checkbox = this.ui.checkbox;

        if ( checkbox.prop('checked') === true ) {
            checkbox.prop('checked', false);
            this.trigger('child_selected');
        } else {
            checkbox.prop('checked', true);
            this.trigger('child_selected');
        }
    },
    v5_object_regions: function(){
        return [
            { name: 'group', model: this.model.rel.get('devicegroup'), link: false},
            { name: 'product', model: this.model.rel.get('product'), link: false }
        ];
    },
    assign_devices_view: true
});

var AssignDevicesDialog = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(assign_devices_template),
    ui: {
        table_container: '.table-container',
        response_container: '.response-container',
        submit_btn: 'button[type=submit]',
        try_again_btn: '.try-again'
    },
    regions: {
        devices_table: '.devices-table',
        response: '.response'
    },
    events: {
        'submit': 'on_submit',
        'click @ui.try_again_btn': 'show_devices_table'
    },
    initialize: function(options) {
        this.destroyOnClose();
        this.mergeOptions(options, ['devicegroup']);
        _.bindAll(this, ['on_success']);
    },
    initialize_devices_table: function() {
        this.devices_table = new CollectionTableView({
            collection: this.collection,
            childView: AssignDevicesDeviceView,
            childViewOptions: {
                tagName: 'tr',
                show: {
                    rel_owner: false,
                    rel_account: false,
                    rel_product: true,
                    rel_devicegroup: true,
                    last_enrolled: true,
                    actions: false
                }
                
            },
            class_name: 'devices-list',
            default_sort_column: 5,
            default_sort_desc: true,
            columns: [
                {
                    name: '',
                    class_name: 'select',
                    sortable: false,
                    select_all: true,
                },
                {
                    name: 'Device ID / Name',
                    class_name: 'device-name',
                },
                {
                    name: 'Status',
                    class_name: 'account',
                },
                {
                    name: 'Product',
                    class_name: 'product'
                },
                {
                    name: 'Device Group',
                    class_name: 'group'
                },
                {
                    name: 'Last Enrolled',
                    class_name: 'enrolled',
                    sort_by: 'last_enrolled_at',
                },
            ],
            filter: this.options.filter,
        });

        this.showChildView('devices_table', this.devices_table);

        this.listenTo(this.devices_table, 'child_selected select_all deselect_all', this.toggle_submit_btn);
    },
    show_devices_table: function() {
        this.ui.response_container.hide();
        this.ui.table_container.show();
    },
    show_response: function() {
        this.ui.table_container.hide();
        this.ui.response_container.show();
    },
    onRender: function() {
        this.initialize_devices_table();
    },
    toggle_submit_btn: function(selected) {
        var has_selected_items = selected.length > 0;
        this.ui.submit_btn.prop('disabled', !has_selected_items);
    },
    on_submit: function(e) {
        e.preventDefault();
        this.ui.submit_btn.prop('disabled', true);

        var selected = this.devices_table.get_selected_models();
        var device_ids = _.pluck(selected, 'id');
        this.devicegroup.bulk_assign_devices(device_ids)
            .done(function() {
                this.on_success(device_ids);
            }.bind(this))
            .fail(function(response) {
                this.on_error(response, device_ids);
            }.bind(this));
    },
    on_success: function(device_ids) {
        this.showAlert('success', 'Successfully assigned devices');
        this.devicegroup.trigger('change:devices', device_ids);
        setTimeout(this.closeDialog.bind(this), 1000);
    },
    on_error: function(response, device_ids) {
        var meta = response.responseJSON.meta;

        // Re-rendering will remove any successfully moved devices from the list.
        // We then reselect the failed devices in case the user wants to try again.
        this.render();
        this.ui.submit_btn.prop('disabled', false);
        this.devices_table.children
            .filter(function(device_view) {
                return _.contains(device_ids, device_view.model.id);
            })
            .forEach(function(selected_device_view) {
                selected_device_view.$('input[type="checkbox"]').prop('checked', true);
            });

        if (!meta) { return; }

        // Show generic num_failed message
        var num_failed = meta.total - meta.succeeded;
        var device_or_devices = num_failed === 1 ? 'device' : 'devices';
        this.showAlert(
            'error',
            num_failed + ' ' + device_or_devices + ' could not be assigned.'
        );

        // Show detailed error info
        var response_results_view = new ResponseResultsView({
            resp: response,
            values: device_ids
        });
        this.show_response();
        this.showChildView('response', response_results_view);
    },
});

export default AssignDevicesDialog;

